import React, { FC, useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Content, PageHeader, SmallInput, Button, SelectField, Label, useNotification, TypeTable, ButtonWithLoading, Switch } from 'scorer-ui-kit';
import { Divider } from 'Styles';
import { getPatlite, savePatlite, sendAlert, delPatlite } from 'services/apiConfig';
import type { PaginationProps } from 'antd';
import { Pagination } from 'antd';

const Container = styled(Content)`
  // @media screen and (min-width: 1920px) {
  //   padding-left: 168px;
  //   padding-right: 168px;
  // }
`;

const HeaderContainer = styled.div`
  margin-bottom: 47px;
  > div:first-child > div > h1 {
    max-width: 650px;
    overflow-wrap: break-word;
    white-space: break-spaces;
    min-width: 200px !important;
  }
  & > div > div > div:nth-child(3){
    bottom: 4px;
  }
  & > div > p {
    font-weight: normal;
    font-style: normal;
  }
  position: relative;
  max-width: 940px !important;
`;

const InnerContainer = styled.div`
  margin-left: 1px;
`;

const BackLinkNonHover = styled.label`
  font-family: ${({ theme }) => theme.fontFamily.ui}; 
  font-size: 12px;
  font-weight: 500;
  color: #7c8793;
  margin-bottom: 4px;
  line-height: 12px;
  text-decoration: none;
`;

const PageHeaderFormatter = styled.div`
  svg {
    margin-top: -7px;
  }
`;

const LeftPanel = styled.div`
  float: left;
  width: 30%;
  flex-direction: column;
`;

const LeftInner = styled.div`
  border-radius: 3px;
  border: solid 1px #eee;
  padding: 10px 10px 10px 10px;
  position: relative;
`;

const RightPanel = styled.div`
  float: right;
  width: 70%;
  padding: 0px 10px 10px 20px;
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 9px;
  align-items: center;
  margin-bottom: 10px;
`;

const SubTitle = styled.label`
  font-size: 14px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  color: #5a6269;
  margin: 0;
  padding: 0;
`;

const StyledSmallInputWithLabel = styled(SmallInput) <ISmallInput>`
  & > label {
    width: 100%;
    margin-bottom: 0;
    font-size: 12px;
    & > span {width: 150px;}
  }
`;

const DividerWithMargin = styled(Divider)`
  margin: 14px 0 12px;
`;

const TestButton = styled(Button)`
  display: block;
  width: 100%;
  background: #2ADD81;
  :hover:enabled {
    background: #27CA76;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  padding: 10px 0px;
`;

const RegisterButton = styled(Button)`
  display: block;
  width: 100%;
  background: #FF5733;
  :hover:enabled {
    background: #FC431B;
  }
`;

const DeleteButton = styled(Button)`
  display: block;
  width: 100%;
  background: #FB2E56;
  :hover:enabled {
    background: #E02E51;
  }
`;

const SaveButton = styled(ButtonWithLoading)`
  display: block;
  width: 100%;
  background: #3FAFE5;
  :hover:enabled {
    background: #1499D8;
  }
`;

const CancelButton = styled(Button)`
  display: block;
  margin: 15px 0;
  width: 100%;
  background: #3FAFE5;
  :hover:enabled {
    background: #1499D8;
  }
`;

const StyledSelectField = styled(SelectField)`
  background: #fff;
  &:disabled {
    opacity: 0.7;
  }
  & + div {
    top: 50% !important;
    transform: translateY(-50%) !important;
  }
`;

const LabelWithMargin = styled(Label)`
  margin-bottom: 10px;
  & > span {
    margin-bottom: 10px;
  }
  font-size: 12px;
`;

const TableContainer = styled.div`
  table, th, td {
    border: 1px solid black;
    border-collapse: collapse;
  }
  th, td {
    padding: 5px;
  }
  th {
    text-align: left;
  }
  margin: 60px 0px;
`;

const BlurText = styled.div`
  font-weight: bold;
  font-size: 25px;
  text-align: center;
  vertical-align: middle;
  z-index: 2;
  position: absolute;
  top: 50%;
  left: 5%;
`;


interface ISmallInput {
    length: string;
  }

const Patlite: FC = () => {
  const { t } = useTranslation(['CommonDict']);
  const [isReadOnly, setIsReadOnly] = useState<boolean>(false);
  const { sendNotification } = useNotification();
  const [patliteData, setPatliteData] = useState<any>([]);
  const [selectedPatliteId, setSelectedPatliteId] = useState('');
  const [saveLoading, setSaveLoading] = useState<boolean>(false);
  const buzzerPattern = ['停止', '連続音', 'スイープ音', '断続音', '弱注意音', '強注意音', 'きらきら星', 'ロンドン橋'];
  const buzzerRepeat = ['連続動作', '1回', '2回', '3回', '4回', '5回'];
  const buzzerVolume = ['無音', '1', '2', '3', '4', '5', '6', '7', '8', '9', '最大'];
  const ledColor = ['消灯', '赤', '緑', '黄', '青', '紫', '水色', '白'];
  const ledPattern = ['消灯', '点灯', 'パターン No1', 'パターン No2', 'パターン No3', 'パターン No4', 'パターン No5', 'パターン No6'];

  const [pageContent, setPageContent] = useState<any>([]);
  const [tableLoading, setTableLoading] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const showTotal: PaginationProps['showTotal'] = (total) => `${t('total usb pattern setting')} ${total}`;

  const columnConfig: any=[
    {
      cellStyle: 'normalImportance',
      header: t('id'),
      alignment: 'center',
      columnId: 'id',
      sortable: true
    },
    {
      cellStyle: 'normalImportance',
      header: t('Notification Name'),
      alignment: 'center',
      columnId: 'patliteId',
      sortable: true
    },
    {
      cellStyle: 'normalImportance',
      header: t('Buzzer Pattern'),
      alignment: 'center',
      columnId: 'buzzer_pattern',
      sortable: true
    },
    {
      cellStyle: 'normalImportance',
      header: t('Buzzer Repeat'),
      alignment: 'center',
      columnId: 'buzzer_repeat',
      sortable: true
    },
    {
      cellStyle: 'normalImportance',
      header: t('Buzzer Volume'),
      alignment: 'center',
      columnId: 'buzzer_volume',
      sortable: true
    },
    {
      cellStyle: 'normalImportance',
      header: t('Led Color'),
      alignment: 'center',
      columnId: 'led_color',
      sortable: true
    },
    {
      cellStyle: 'normalImportance',
      header: t('Led Pattern'),
      alignment: 'center',
      columnId: 'led_pattern',
      sortable: true
    },
    {
      cellStyle: 'normalImportance',
      header: t('Enabled'),
      alignment: 'center',
      columnId: 'enabled',
      sortable: true
    }
  ];


  const onGetPatlite = useCallback(async () => {
    setTableLoading(true);
    try {
      const response = await getPatlite();
      if(response.status === 200) {
        setPatliteData(response.data.data);
        setTableLoading(false);
      }
    }
    catch {
      sendNotification({ type: 'error', message: t('Failed to get patlite data') });
      setTableLoading(false);
    }
  }, [t, sendNotification]);

  useEffect(() => {
    onGetPatlite();
  }, [onGetPatlite]);

  function findById(myArr:any, id:any) {
    if(myArr.length > 0){
      return myArr.find((x:any) => x.id === Number(id));
    } else {
      return '';
    }
    
  }

  const handleChangePatlite = useCallback((e, type) => {
    const copiedData = [...patliteData];
    const objIndex = copiedData.findIndex((obj:any) => obj.id === Number(selectedPatliteId));
    if(type === 'name'){
      copiedData[objIndex].name = e.target.value;
    } else if(type=== 'buzzer_pattern'){
      copiedData[objIndex].buzzer_pattern = e;
    } else if(type=== 'buzzer_repeat'){
      copiedData[objIndex].buzzer_repeat = e;
    } else if(type=== 'buzzer_volume'){
      copiedData[objIndex].buzzer_volume = e;
    } else if(type=== 'led_color'){
      copiedData[objIndex].led_color = e;
    } else if(type=== 'led_pattern'){
      copiedData[objIndex].led_pattern = e;
    } else if(type=== 'enabled'){
      if(e){
        copiedData[objIndex].enabled = 1;
      } else {
        copiedData[objIndex].enabled = 0;
      }
      
    }
    setPatliteData(copiedData);
  }, [patliteData, selectedPatliteId]);

  



  const generateNewId = (num:any) => {
    if(num.length > 0){
      const max = Math.max(...num); // Will find highest number
      const min = Math.min(...num); // Will find lowest number
      const missing = [];
    
      for(let i=min; i<= max; i++) {
        if(!num.includes(i)) { // Checking whether i(current value) present in num(argument)
          missing.push(i); // Adding numbers which are not in num(argument) array
        }
      }
      if(missing.length > 0){
        return missing;
      }else {
        return max + 1;
      }
    } else {
      return 1;
    }
    
    
  };

  const addPatlite = useCallback(async () => {
    const idArr = patliteData.map((a:any) => a.id);
    const newId = generateNewId(idArr);

    const newData = {'id': newId, 
      'name': 'new_patlite', 
      'buzzer_pattern': '', 
      'buzzer_repeat': '', 
      'buzzer_volume': '', 
      'led_color': '', 
      'led_pattern': '',
      'enabled': 1
    };


    const copiedData = JSON.parse(JSON.stringify(patliteData));
    copiedData.push(newData);
    setPatliteData(copiedData);
    setSelectedPatliteId(newId.toString());
  }, [patliteData]);

  const removePatlite = useCallback(async () => {
    if(!selectedPatliteId){
      sendNotification({ type: 'error', message: t('Please choose Patlite') });
      return;
    }

    try {
      const copiedData = [...patliteData];
      const newData = copiedData.filter((x:any) => x.id !== Number(selectedPatliteId));
      setPatliteData(newData);
      setSelectedPatliteId('');

      const response = await delPatlite(selectedPatliteId);
      if(response.status === 200) {
        sendNotification({ type: 'success', message: t('Deletion successful') });
      }
    }
    catch {
      sendNotification({ type: 'error', message: t('Deletion Failed') });
      setTableLoading(false);
    }
  }, [t, patliteData, sendNotification, selectedPatliteId]);

  const handleTableData = useCallback(() => {
    if(patliteData.length > 0){
      const arrData = [];
      const copiedObj = [...patliteData].slice((page - 1) * pageSize, page * pageSize);
      for (let i = 0; i < copiedObj.length; i++) {
        arrData.push({columns: [ 
          {text: copiedObj[i].id}, 
          {text: copiedObj[i].name}, 
          {text: copiedObj[i].buzzer_pattern}, 
          {text: copiedObj[i].buzzer_repeat}, 
          {text: copiedObj[i].buzzer_volume},
          {text: copiedObj[i].led_color},
          {text: copiedObj[i].led_pattern},
          {text: copiedObj[i].enabled ? '有': '無'}
        ],
        id: `tblrow${i+1}`});
      } 
      setPageContent(arrData);

      //wait until table shows up
      setTimeout(function(){
        const tblRows = document.getElementById('patTbl')?.childNodes[0].childNodes[0].childNodes;
        if(tblRows){
          //全ての行をクリック可能にする
          for (let x = 1; x < tblRows.length; x++) {
            const tblCells = tblRows[x].childNodes;
            for (let y = 0; y < tblCells.length; y++) {
              const id_val = tblCells[0]?.textContent;
              if(id_val){
                (tblCells[y] as HTMLElement).style.cursor = 'pointer';
                (tblCells[y] as HTMLElement).onclick = function() { setSelectedPatliteId(id_val); };
                
              }
            }
          }
        }
      }, 100);

    } else {
      setPageContent([{ columns: [] }]);
    }
      
    
  },[patliteData, page, pageSize]);
  
  
  useEffect(() => {
    handleTableData();
  }, [handleTableData]);

  const savePatliteData = useCallback(async (is_alerttest: boolean = false) => {

    setSaveLoading(true);
    setIsReadOnly(true);


    try {
      const response = await savePatlite({'patliteData': patliteData});
      if (response.data.status_code !== 200) {
        sendNotification({ type: 'error', message: response.data.message });
      }else{
        if(response.status === 200) {
          if (is_alerttest === false){ sendNotification({ type: 'success', message: t('Saved patlite successfully') });}
        } else {
          sendNotification({ type: 'error', message: t('Failed to save patlite.') });
        }
      }
    } catch (error) {
      console.log(error);
      sendNotification({ type: 'error', message: t('Failed to save patlite.') });
    }
    setSaveLoading(false);
    setIsReadOnly(false);
  }, [patliteData, sendNotification, t]);

  const resetButton = useCallback(async () => {
    if(selectedPatliteId){
      const copiedData = [...patliteData];
      const objIndex = copiedData.findIndex((obj:any) => obj.id === Number(selectedPatliteId));
      copiedData[objIndex] = {'id': Number(selectedPatliteId), 
        'name': '', 
        'buzzer_pattern': '', 
        'buzzer_repeat': '', 
        'buzzer_volume': '', 
        'led_color': '', 
        'led_pattern': '',
        'enabled': 1
      };
      setPatliteData(copiedData);
    } 
  }, [patliteData, selectedPatliteId]);

  const testAlert = useCallback(async () => {    
    setIsReadOnly(true);
    try {
      const response = await sendAlert({'patliteData': findById(patliteData, selectedPatliteId)});
      if (response.data.status_code !== 200) {
        sendNotification({ type: 'error', message: response.data.message });
      }else{
        if(response.status === 200) {
          sendNotification({ type: 'success', message: t('Sent Alert Successfully.') });
        } else {
          sendNotification({ type: 'error', message: t('Failed to send alert.') });
        }
      }
    } catch (error) {
      console.log(error);
      sendNotification({ type: 'error', message: t('Failed to send alert.') });
    }
    setIsReadOnly(false);
  }, [patliteData, sendNotification, t, selectedPatliteId]);

  const handleBlurriness = useCallback(async () => {
    try {
      const blurPanel = document.getElementById('blurPanel') as HTMLInputElement;
      const blurText = document.getElementById('blurText') as HTMLInputElement;
      if(!selectedPatliteId){
        blurPanel.setAttribute('z-index','0');
        blurPanel.setAttribute('style','filter:blur(8px)');
        blurText.setAttribute('style','');
      } else {
        blurText.setAttribute('style','display: none');
        blurPanel.setAttribute('style','');
      }
    }
    catch(err) {
      console.log(err);
    }
  }, [selectedPatliteId]);

  useEffect(() => {
    handleBlurriness();
  }, [handleBlurriness]);



  return (
    <Container>
      <HeaderContainer>
        <BackLinkNonHover>{t('Settings')}</BackLinkNonHover>
        <PageHeaderFormatter>
          <PageHeader
            title={t('USB Patlite Settings')}
            icon='ViewSettings'
            updateDocTitle={false}
          />
        </PageHeaderFormatter>
      </HeaderContainer>
      <InnerContainer>
        <>
          <LeftPanel>
            <FlexContainer>
              <SubTitle>{t('USB Patlite Settings Editing Column (Partially editable)')}</SubTitle>
            </FlexContainer>
            <LeftInner id='leftInner'>
              <BlurText id='blurText'>{t('Please choose Patlite')}</BlurText>
              <div id='blurPanel'>
                <StyledSmallInputWithLabel
                  fieldState='default'
                  label={t('Notification ID (not editable)')}
                  name='alertId'
                  length='290px'
                  disabled
                  value={selectedPatliteId ? findById(patliteData, selectedPatliteId).id : ''}
                />
                <CancelButton disabled={selectedPatliteId === '' || isReadOnly} design='primary' onClick={resetButton}>{t('Input Reset')}</CancelButton>
                <StyledSmallInputWithLabel
                  fieldState='default'
                  label={t('Notification Name')}
                  name='alertName'
                  length='290px'
                  disabled={selectedPatliteId === '' || isReadOnly}
                  value={selectedPatliteId ? findById(patliteData, selectedPatliteId).name : ''}
                  onChange={(e) => handleChangePatlite(e, 'name')}
                />
                <DividerWithMargin />
                <div>
                  <LabelWithMargin
                    htmlFor='buzzer_pattern'
                    labelText={t('Buzzer Pattern')}
                  />
                  <StyledSelectField
                    changeCallback={(e) => { handleChangePatlite(e, 'buzzer_pattern'); }}
                    placeholder='Buzzer Pattern Selection'
                    value={selectedPatliteId ? findById(patliteData, selectedPatliteId).buzzer_pattern : ''}
                    disabled={selectedPatliteId === '' || isReadOnly}
                  >
                    {
                      buzzerPattern.map((item: any, index: any) => {
                        return (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        );
                      })
                    }
                  </StyledSelectField>
                </div>
                <DividerWithMargin />
                <div>
                  <LabelWithMargin
                    htmlFor='buzzer_repeat'
                    labelText={t('Buzzer Repeat')}
                  />
                  <StyledSelectField
                    changeCallback={(e) => { handleChangePatlite(e, 'buzzer_repeat'); }}
                    placeholder='Buzzer Repeat Selection'
                    value={selectedPatliteId ? findById(patliteData, selectedPatliteId).buzzer_repeat : ''}
                    disabled={selectedPatliteId === '' || isReadOnly}
                  >
                    {
                      buzzerRepeat.map((item: any, index: any) => {
                        return (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        );
                      })
                    }
                  </StyledSelectField>
                </div>
                <DividerWithMargin />
                <div>
                  <LabelWithMargin
                    htmlFor='buzzer_volume'
                    labelText={t('Buzzer Volume')}
                  />
                  <StyledSelectField
                    changeCallback={(e) => { handleChangePatlite(e, 'buzzer_volume'); }}
                    placeholder='Buzzer Volume Selection'
                    value={selectedPatliteId ? findById(patliteData, selectedPatliteId).buzzer_volume : ''}
                    disabled={selectedPatliteId === '' || isReadOnly}
                  >
                    {
                      buzzerVolume.map((item: any, index: any) => {
                        return (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        );
                      })
                    }
                  </StyledSelectField>
                </div>
                <DividerWithMargin />
                <div>
                  <LabelWithMargin
                    htmlFor='led_color'
                    labelText={t('Led Color')}
                  />
                  <StyledSelectField
                    changeCallback={(e) => { handleChangePatlite(e, 'led_color'); }}
                    placeholder='Led Color Selection'
                    value={selectedPatliteId ? findById(patliteData, selectedPatliteId).led_color : ''}
                    disabled={selectedPatliteId === '' || isReadOnly}
                  >
                    {
                      ledColor.map((item: any, index: any) => {
                        return (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        );
                      })
                    }
                  </StyledSelectField>
                </div>
                <DividerWithMargin />
                <div>
                  <LabelWithMargin
                    htmlFor='led_pattern'
                    labelText={t('Led Pattern')}
                  />
                  <StyledSelectField
                    changeCallback={(e) => { handleChangePatlite(e, 'led_pattern'); }}
                    placeholder='Led Pattern Selection'
                    value={selectedPatliteId ? findById(patliteData, selectedPatliteId).led_pattern : ''}
                    disabled={selectedPatliteId === '' || isReadOnly}
                  >
                    {
                      ledPattern.map((item: any, index: any) => {
                        return (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        );
                      })
                    }
                  </StyledSelectField>
                </div>
                <DividerWithMargin />
                <div>
                  <LabelWithMargin
                    htmlFor='enabled'
                    labelText={t('Enabled')}
                  />
                  <Switch
                    checked={selectedPatliteId ? (findById(patliteData, selectedPatliteId).enabled ? true : false) : false}
                    leftTheme='off'
                    onChangeCallback={(e) => handleChangePatlite(e, 'enabled')}
                    rightTheme='on'
                  //   state={isReadOnly ? 'disabled' : 'default'}
                  />
                </div>
              </div>
              
            </LeftInner>
            <TestButton disabled={selectedPatliteId === '' || isReadOnly} design='primary' onClick={()=>{savePatliteData(true);testAlert();}}>{t('Test Alert')}</TestButton>
            <ButtonContainer>
              <RegisterButton design='primary' onClick={addPatlite}>{t('Patlite Sign up')}</RegisterButton>
              <DeleteButton design='primary' disabled={selectedPatliteId === ''} onClick={removePatlite}>{t('Delete')}</DeleteButton>
            </ButtonContainer>
            <SaveButton design='primary' loading={saveLoading} onClick={()=>savePatliteData(false)}>{t('Save')}</SaveButton>
          </LeftPanel>
          <RightPanel>
            <FlexContainer>
              <SubTitle>{t('USB Patlite Settings List')}</SubTitle>
            </FlexContainer>
            <TableContainer id='patTbl'>
              <TypeTable
                columnConfig={columnConfig}
                emptyTableText={t('There is currently no data')}
                emptyTableTitle={t('No Data Available')}
                isLoading={tableLoading}
                loadingText='Loading Data..'
                rows={pageContent}
                // sortCallback={handleSort}
              />
              {patliteData.length > 0 && 
                <Pagination
                  current={page}
                  size='small'
                  pageSize={pageSize}
                  onChange={(newPage, newPageSize) => {
                    setPageSize(newPageSize);
                    setPage(pageSize !== newPageSize ? 1 : newPage);
                  }}
                  // showSizeChanger
                  total={patliteData.length}
                  showTotal={showTotal}
                  style={{ marginTop: '18px', textAlign: 'center'}}
                />}
            </TableContainer>
          </RightPanel>
        </>
      </InnerContainer>
        
    </Container>
  );
};

export default Patlite;